import React, { useState, useEffect } from 'react';
import './companies.css';
import { useNavigate } from 'react-router';
import companyData from '../../../pages/c2wHomePage/companies/companies.json';

function C2wCompanies() {
    const navigate = useNavigate();
    const [countData, setCountData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch('/website.json');
                if (res.ok) {
                    const json = await res.json();
                    setCountData(json);
                }
            } catch (err) {
                console.error('Failed to load stats', err);
            }
        };
        fetchData();
    }, []);

    // Dynamically look up background color from companies.json
    const getCompanyBg = (fileName) => {
        const match = companyData?.companyLogos?.find(
            (c) => c.compName.toLowerCase() === fileName.toLowerCase()
        );
        return match ? match.imgBg : '#ffffff';
    };

    // Staggered company list for 3 marquee rows
    const row1 = [
        { name: "amazon.svg", alt: "Amazon" },
        { name: "ibm.svg", alt: "IBM" },
        { name: "nvidia.svg", alt: "Nvidia" },
        { name: "infosys.svg", alt: "Infosys" },
        { name: "TechmahindraLogo.svg", alt: "Tech Mahindra" },
        { name: "reliance.svg", alt: "Reliance" },
        { name: "amdocs.svg", alt: "Amdocs" },
        { name: "Cognizant.svg", alt: "Cognizant" },
        { name: "Deloitte.svg", alt: "Deloitte" },
        { name: "Hexaware.svg", alt: "Hexaware" },
        { name: "Hcl.svg", alt: "HCL" },
        { name: "capgemini.svg", alt: "Capgemini" }
    ];

    const row2 = [
        { name: "TcsLogo.svg", alt: "TCS" },
        { name: "bitwise.svg", alt: "Bitwise" },
        { name: "ptc.svg", alt: "PTC" },
        { name: "persistent.svg", alt: "Persistent" },
        { name: "wipro.svg", alt: "Wipro" },
        { name: "Accenture.svg", alt: "Accenture" },
        { name: "barclaysLogo.svg", alt: "Barclays" },
        { name: "Fiserv.svg", alt: "Fiserv" },
        { name: "Fujitsu.svg", alt: "Fujitsu" },
        { name: "DeutcheBank.svg", alt: "Deutsche Bank" },
        { name: "neosoftLogo.svg", alt: "Neosoft" },
        { name: "Nice.svg", alt: "NICE" }
    ];

    const row3 = [
        { name: "nvidia.svg", alt: "Nvidia" },
        { name: "TechmahindraLogo.svg", alt: "Tech Mahindra" },
        { name: "amazon.svg", alt: "Amazon" },
        { name: "ibm.svg", alt: "IBM" },
        { name: "reliance.svg", alt: "Reliance" },
        { name: "TcsLogo.svg", alt: "TCS" },
        { name: "veritasLogo.svg", alt: "Veritas" },
        { name: "Zensar.svg", alt: "Zensar" },
        { name: "BNYMellon.svg", alt: "BNY Mellon" },
        { name: "CreditSuisse.svg", alt: "Credit Suisse" },
        { name: "DassaultSystemes.svg", alt: "Dassault Systemes" },
        { name: "Qualitykiosk.svg", alt: "Qualitykiosk" }
    ];

    const renderMarqueeRow = (items, direction) => {
        return (
            <div className="C2wCompanies_marquee_row">
                <div className={`C2wCompanies_marquee_track marquee-${direction}`}>
                    {/* Original list */}
                    {items.map((item, index) => {
                        const bg = getCompanyBg(item.name);
                        return (
                            <div
                                key={`orig-${index}`}
                                className="C2wCompany_marquee_card"
                                style={{ backgroundColor: bg }}
                            >
                                <img src={`/assets/images/companies/${item.name}`} alt={item.alt} loading="lazy" />
                            </div>
                        );
                    })}
                    {/* Duplicate list for infinite loop */}
                    {items.map((item, index) => {
                        const bg = getCompanyBg(item.name);
                        return (
                            <div
                                key={`dup-${index}`}
                                className="C2wCompany_marquee_card"
                                style={{ backgroundColor: bg }}
                            >
                                <img src={`/assets/images/companies/${item.name}`} alt={item.alt} loading="lazy" />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className="C2wHomeCompanies_ctn_redesign">
            {/* Badge pill */}
            <div className="C2wCompanies_badge">
                <span className="badge-icon-circle-blue">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
                    </svg>
                </span>
                <span>Companies</span>
            </div>

            {/* Heading */}
            <h2 className="C2wCompanies_section_heading">
                Students Placed in <span className="highlight-blue-gradient">180+ Companies</span>
            </h2>

            {/* Subheading */}
            <p className="C2wCompanies_section_subheading">
                Building industry-ready skills that lead to real job opportunities.
            </p>

            {/* 3 Marquee Rows */}
            <div className="C2wCompanies_marquee_container">
                {renderMarqueeRow(row1, "left")}
                {renderMarqueeRow(row2, "right")}
                {renderMarqueeRow(row3, "left")}
            </div>

            {/* Footer Text */}
            <div className="C2wCompanies_section_footer" onClick={() => navigate('/companies')}>
                and many more...
            </div>
        </div>
    );
}

export default C2wCompanies;